import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCateFilterListAction, setActiveFilterIdAction } from '../../modules/common/cateModule';
import CateFilter from '../../components/common/CateFilter';

const CateFilterContainerBlock = styled.div``;

const CateFilterContainer = () => {

    const dispatch = useDispatch();
    const { filterItems, curSelCateId, error, loading } = useSelector(
        ({ cateItemsReducer, loadingReducer }) => ({
            filterItems: cateItemsReducer.filterItems,
            curSelCateId: cateItemsReducer.curSelScndCateId,
            error: cateItemsReducer.error,
            loading: loadingReducer['es/LIST_CATE_FILTER'],
        }));

    useEffect(() => {
        // 선택된 2Depth 카테고리가 변경 될 때마다 처리 
        if (curSelCateId != null && curSelCateId > 0) {
            dispatch(getCateFilterListAction(curSelCateId));
        }

        // console.log("CateFilterContainer +++++++");

    }, [dispatch, curSelCateId]);

    // Network Error 공통 처리 필요 
    if (error) {
        return (<CateFilterContainerBlock>
        </CateFilterContainerBlock>)
    }

    return (
        <CateFilterContainerBlock>
            {
                (loading || filterItems === null) ? <div /> : (
                    filterItems.map((filterItem) => {
                        let keyvalue = filterItem.fiter1_id * 100 + filterItem.filter2_id + Math.random() * 100;
                        return (
                            <CateFilter key={keyvalue} filterItem={filterItem} />
                        )
                    })
                )
            }
        </CateFilterContainerBlock>
    );
};

export default CateFilterContainer;